import { useCallback, useEffect, useState } from 'react';
import { __ } from '../../../../shared/tools';
import { FormControl, MenuItem, Select } from '@mui/material';
import { ExpandMore, NotificationsNone } from '@mui/icons-material';
import clsx from 'clsx';
import style from './style.module.scss';

export const SelectAttribute = ({ slug, product, settings = {}, onChange }) => {
    const { attributes, variationAttributes, defaultAttributes } = product;
    const [value, setValue] = useState('');

    const handleChange = useCallback(
        (value) => {
            setValue(value);
            onChange(slug, value);
        },
        [slug, setValue, onChange],
    );

    useEffect(() => {
        // Pour valeur par défaut
        if (!variationAttributes[slug] || Object.keys(variationAttributes[slug]).length === 0 || value.length > 0)
            return;

        if (defaultAttributes && slug in defaultAttributes) {
            handleChange(defaultAttributes[slug]);
        } else {
            const firstInStock = Object.values(variationAttributes[slug]).find((e) => e.is_in_stock === true);
            if (firstInStock) handleChange(firstInStock.key);
        }
    }, [slug, value, defaultAttributes, variationAttributes, handleChange]);

    if (!variationAttributes[slug] || variationAttributes[slug].length === 0) return;

    const { data, label, terms } = attributes[slug];
    return (
        <FormControl className={style.wrapper}>
            <label
                id={'attribute-' + data.name + '-label'}
                htmlFor={'attribute-' + data.name + '-select'}
                className={style.label}
            >
                {label}
            </label>
            <Select
                id={'attribute-' + data.name + '-select'}
                labelId={'attribute-' + data.name + '-label'}
                name={'attributes[' + data.name + ']'}
                value={value}
                label={label}
                onChange={(e) => handleChange(e.target.value)}
                className={style.select}
                MenuProps={{
                    style: {
                        zIndex: 2000,
                    },
                }}
                IconComponent={ExpandMore}
            >
                {variationAttributes[slug] &&
                    terms.map((term) => {
                        const variationAttribute = Object.values(variationAttributes[slug]).find(
                            (element) => element.key === term.slug,
                        );
                        return variationAttribute ? (
                            <MenuItem
                                value={variationAttribute.key}
                                key={variationAttribute.key}
                                className={clsx(style.item, !variationAttribute.is_in_stock && style.out_of_stock)}
                            >
                                <span className={style.name}>{term.name}</span>
                                {!variationAttribute.is_in_stock && (
                                    <span className={style.alert}>
                                        <NotificationsNone />
                                        {__('Me prévenir')}
                                    </span>
                                )}
                            </MenuItem>
                        ) : null;
                    })}
            </Select>
        </FormControl>
    );
};

export default SelectAttribute;
